var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-language-switcher"},_vm._l(([
        'nl',
        'fr',
        // 'en',
        ]),function(locale,i){return _c('span',{key:`language-${i}`,attrs:{"value":locale}},[_vm._v("   "),_c('a',{class:(_vm.language === locale)?'item --active':'item',attrs:{"value":locale,"href":'/' + locale}},[_vm._v(_vm._s(locale))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }